import { ConnectorId } from "../domain/ConnectorId"

export class VueConnectorIdsScreenData {
    data : ConnectorId[] = []
    headers = [
        {
            text: 'Nombre',
            value: 'name',
        },
        {
            text: 'Estado',
            value: 'current',
            sortable: false
        },
        {
            text: '',
            value: 'actions',
        }
    ]
    loadingSetCurrent = false
    newName = ''
    constructor(){

    }
}